/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_available_soon = /** @type {(inputs: {}) => string} */ () => {
	return `Muy pronto disponible.`
};

const en_accounts_available_soon = /** @type {(inputs: {}) => string} */ () => {
	return `Available soon.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_available_soon = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_available_soon(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_available_soon", locale)
	if (locale === "es") return es_accounts_available_soon(inputs)
	return en_accounts_available_soon(inputs)
};
export { accounts_available_soon as "accounts.available_soon" }